const GRADIENT_PALETTE = {
  primary: {
    start: '#F40009',
    end: '#FFA95D',
  },
} as const

export const GradientDefs = () => {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: 'absolute' }}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="linear-primary-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={GRADIENT_PALETTE.primary.start} />
          <stop offset="100%" stopColor={GRADIENT_PALETTE.primary.end} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GradientDefs

